import config from '../../config'
import fetch from '../../lib/wrappedFetch'

class VariantsStockService {
  fetchVariantStoreStocks = ({ variantId }) => {
    return fetch(config.config.endpointUrls.fetchVariantStoreStocks({ variantId }), {
      method: 'GET'
    })
  }
}

export default new VariantsStockService()



// WEBPACK FOOTER //
// ../src/services/variantsStockService/variantsStockService.js